<template>
  <div>
    <p v-if="!show">
      {{ truncate(text) }}
      <a
        v-if="checkVariable(text) && text.length >= length"
        @click="toggle()"
        :class="actionClass"
      >{{ clamp || $t('text_read_more') }}</a>
    </p>
    <p v-if="show">
      {{text}}
      <a
        @click="toggle()"
        v-if="checkVariable(text) && text.length >= length"
        :class="actionClass"
      >{{ less || $t('text_show_less') }}</a>
    </p>
  </div>
</template>
<script>
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  name: 'v-truncate',
  props: {
    text: {
      type: String,
      default: '',
    },
    clamp: {
      type: String,
      default: '...',
    },
    length: {
      type: Number,
      default: 50,
    },
    less: {
      type: String,
      default: '',
    },
    actionClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      counter: this.length,
    }
  },
  methods: {
    truncate(string) {
      if (this.checkVariable(string)) {
        return string.toString().substring(0, this.length || 100)
      }

      return ''
    },
    toggle() {
      this.show = !this.show
    },
  },
}
</script>
<style lang="css" scoped>
a {
  cursor: pointer;
}
</style>
